import { 
  Menu, Bell
} from 'lucide-react';
// import { useTranslation } from '../i18n/i18n';
import SearchBar from './Searchbar';
import ProfileDropdown from './ProfilDropdown';

const Topbar = ({ onMenuClick, lang, onLangChange, onLogout, userData  }) => {

  return (
    <header style={{
      position: 'sticky',
      top: 0,
      height: '70px',
      background: 'white',
      borderBottom: '1px solid #f0f0f0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 20px',
      zIndex: 997
    }}>
      {/* Menu Button (mobile) */}
      <button
        onClick={onMenuClick}
        style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: '8px',
          display: 'flex',
          alignItems: 'center',
          color: '#7c3aed'
        }}
      >
        <Menu size={24} />
      </button>

        <SearchBar lang={lang} />
      {/* Right Section */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexShrink: 0, position: 'relative' }}>
        {/* Language Selector */}
        <select
          value={lang}
          onChange={(e) => onLangChange(e.target.value)}
          style={{
            padding: '8px 12px',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            background: 'white',
            cursor: 'pointer',
            fontSize: '14px',
            color: '#666',
            flexShrink: 0,
          }}
        >
          <option value="fr">FR</option>
          <option value="en">EN</option>
          <option value="es">ES</option>
        </select>

        {/* Notifications */}
        <button
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            display: 'flex',
            alignItems: 'center',
            color: '#666',
            position: 'relative'
          }}
        >
          <Bell size={20} />
          <span style={{
            position: 'absolute',
            top: '4px',
            right: '4px',
            width: '8px',
            height: '8px',
            background: '#ef4444',
            borderRadius: '50%'
          }}></span>
        </button>

        {/* Profile */}
        <ProfileDropdown 
          onLogout={onLogout} 
          userData={userData} 
          lang={lang}
        />
      </div>
    </header>
  );
};

export default Topbar;